import { render, staticRenderFns } from "./page-content-creator.vue?vue&type=template&id=10dd139a"
import script from "./page-content-creator.vue?vue&type=script&lang=js"
export * from "./page-content-creator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports